<app-grid #grid [rowSelection]="'multiple'" [domLayout]="'autoHeight'" [columnDefs]="columnDefs" [rowData]="rowData"
  [useAddAction]="!showDetail" [addLabel]="'Add'" [pagination]="false" [rowMultiSelectWithClick]="true"
  [suppressRowClickSelection]="true" [isProjectOwnershipValid]="true" (addEvent)="onAdd($event)"
  (deleteEvent)="onDelete($event)" (buttonExpandParams)="onButtonExpandClick($event)"
  (onSelectedRowEvent)="onRunSelectionChanged($event)" (onRowSelectedEmit)="onRunSelectionAllChanged($event)"
  (dropDownSelectionChangeEvent)="onDataSetFieldChanged()" (onBlurInputText)="onDataSetFieldChanged()"
  (onClickButtonEvent)="onStudyOptionsClick($event)"></app-grid>

<app-ef-data-study-options *ngIf="showStudyOptions && studyOptionsRow" [dataSetRow]="studyOptionsRow"
  [efateSetupPk]="currentEfateSetupPk" (saved)="onStudyOptionsSaved($event)"
  (closed)="onStudyOptionsClosed()"></app-ef-data-study-options>

<div class="ef-data-detail" *ngIf="showDetail && expandedRow">
  <div class="ef-data-group-selector">
    <label class="ef-data-group-label" for="efDataGroupSelect">Select Data Group:</label>
    <select id="efDataGroupSelect" class="ef-data-group-input" [style.background-color]="selectedGroupColor"
      [ngModel]="expandedRow.dataGroupKey" (ngModelChange)="onDataGroupChange($event)">
      <option *ngFor="let group of dataGroupOptions" [value]="group.groupKey"
        [style.background-color]="getGroupColor(group.groupKey)">{{ group.groupName }}</option>
    </select>
  </div>

  <div class="ef-data-detail-body">
    <div class="ef-data-topology-card" [style.--group-color]="selectedGroupColor">
      <app-ef-cake-topology-structure [readonlyMode]="true" sizeVariant="small" [groupColor]="selectedGroupColor"
        [nodeNames]="topologyNodeNames" [activeEdges]="selectedGroupActiveEdges"
        [activeStatusNodes]="selectedGroupActiveStatusNodes"
        [bidirectionalEdgeDirections]="selectedGroupBidirectionalEdges">
      </app-ef-cake-topology-structure>
    </div>

    <div class="ef-data-experiment-card">
      <ag-grid-angular class="ag-theme-alpine ef-data-experiment-grid" [style.height]="experimentGridHeight"
        [columnDefs]="experimentColumnDefs" [rowData]="experimentRowData" [defaultColDef]="experimentDefaultColDef"
        [rowHeight]="experimentRowHeight" [headerHeight]="experimentHeaderHeight" [enableRangeSelection]="true"
        [suppressCopyRowsToClipboard]="false" [stopEditingWhenCellsLoseFocus]="true"
        [processDataFromClipboard]="processDataFromClipboard" (gridReady)="onExperimentGridReady($event)"
        (cellValueChanged)="onExperimentCellValueChanged()">
      </ag-grid-angular>
    </div>
  </div>
</div>
